import React, { useState } from 'react';
import './App.css';

function YouTubeSearch({ onVideoSelect, apiError, onSearchError, disabled = false, variant = 'default', onSelected }) {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);

  const YOUTUBE_API_KEY = process.env.REACT_APP_YOUTUBE_API_KEY;

  const handleSearch = async (e) => {
    e.preventDefault();
    
    if (!searchQuery.trim()) return;
    if (disabled) return;

    if (!YOUTUBE_API_KEY) {
      onSearchError('YouTube API key is not configured. Please add REACT_APP_YOUTUBE_API_KEY to your environment variables.');
      return;
    }

    setIsSearching(true);
    try {
      const response = await fetch(
        `https://www.googleapis.com/youtube/v3/search?part=snippet&type=video&q=${encodeURIComponent(searchQuery)}&key=${YOUTUBE_API_KEY}&maxResults=10`
      );

      if (!response.ok) {
        const errorData = await response.json();
        const errorMessage = errorData.error?.message || 'Unknown error';
        throw new Error(`YouTube API Error: ${errorMessage}`);
      }

      const data = await response.json();
      const items = (data.items || []).filter((video) => {
        const title = (video.snippet?.title || '').toLowerCase();
        return !title.includes('shorts') && !title.includes('#short');
      });
      setSearchResults(items);
    } catch (error) {
      console.error('Error searching videos:', error);
      onSearchError(error.message);
    } finally {
      setIsSearching(false);
    }
  };

  const handleSelectVideo = (video) => {
    onVideoSelect(video);
    if (onSelected) onSelected(video);
    setSearchResults([]);
    setSearchQuery('');
  };

  return (
    <div className={`youtube-search-container ${variant === 'compact' ? 'compact' : ''}`}>
      <form onSubmit={handleSearch} className="youtube-search-form">
        <input
          type="text"
          placeholder={disabled ? 'YouTube search unavailable…' : 'Search YouTube videos...'}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="youtube-search-input"
          disabled={disabled}
        />
        <button 
          type="submit" 
          className="youtube-search-btn"
          disabled={isSearching || disabled}
        >
          {isSearching ? 'Searching...' : 'Search'}
        </button>
      </form>

      {apiError && (
        <div className="youtube-error">
          {apiError}
        </div>
      )}

      {searchResults.length > 0 && (
        <div className="youtube-results">
          {searchResults.map((video) => (
            <div key={video.id.videoId} className="youtube-result-item">
              <img 
                src={video.snippet.thumbnails.default.url} 
                alt={video.snippet.title}
                className="youtube-result-thumbnail"
              />
              <div className="youtube-result-info">
                <div className="youtube-result-title">
                  {video.snippet.title}
                </div>
                <div className="youtube-result-channel">
                  {video.snippet.channelTitle}
                </div>
              </div>
              <button
                className="youtube-result-select-btn"
                onClick={() => handleSelectVideo(video)}
              >
                Select
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default YouTubeSearch;
